import React from 'react'
import { UseFormRegister, FieldErrors, UseFormWatch } from 'react-hook-form'
import { getEarliestMoveInDate } from '../../../../utils'
import { StorageFormValues } from '../config/validationSchema'

interface LeaseDetailsStepProps {
  register: UseFormRegister<StorageFormValues>
  errors: FieldErrors<StorageFormValues>
  watch: UseFormWatch<StorageFormValues>
  space: any
}

const LeaseDetailsStep: React.FC<LeaseDetailsStepProps> = ({
  register,
  errors,
  watch,
  space
}) => {
  const moveInDate = watch('move_in_date')
  const moveOutDate = watch('move_out_date')

  return (
    <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
      <div style={{ marginBottom: '1.5rem' }}>
        <label className="forceBlack">Move-In Date</label>
        <input
          id="move_in_date"
          style={{ width: '100%', backgroundColor: 'white', color: moveInDate ? '#232043' : '#888', cursor: 'pointer' }}
          type="date"
          min={getEarliestMoveInDate()}
          {...register('move_in_date')}
          onClick={(e) => {
            try {
              (e.target as HTMLInputElement).showPicker?.();
            } catch {
              // showPicker not supported
            }
          }}
          required
        />
        {errors.move_in_date && <div className="input-feedback">{errors.move_in_date.message}</div>}
      </div>

      <div style={{ marginBottom: '1.5rem' }}>
        <label className="forceBlack">
          Move-Out Date <span style={{ fontSize: 14 }}>(optional)</span>
        </label>
        <input
          id="move_out_date"
          min={moveInDate ? String(moveInDate) : undefined}
          disabled={!moveInDate}
          style={{
            width: '100%',
            backgroundColor: 'white',
            color: moveOutDate ? '#232043' : '#888',
            cursor: moveInDate ? 'pointer' : 'not-allowed',
            opacity: moveInDate ? 1 : 0.6
          }}
          type="date"
          {...register('move_out_date')}
          onClick={(e) => {
            if (moveInDate) {
              try {
                (e.target as HTMLInputElement).showPicker?.();
              } catch {
                // showPicker not supported
              }
            }
          }}
        />
      </div>

      {space.type.indexOf("gated") > 0 && (
        <div style={{ marginBottom: '1.5rem' }}>
          <p className="forceBlack" style={{ marginBottom: '0.75rem', fontSize: '1rem' }}>
            <strong>NOTE: </strong>
            Gate access during business hours is included at no additional cost and allows up to two visits per week.
            If you need additional access, you may add one or both of the options below.
            (select both for unlimited 24/7 access):
          </p>

          <div style={{ marginTop: '1.25rem', marginBottom: '0.75rem' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
              <input
                className="checkbox"
                id="need_24hr_access"
                type="checkbox"
                {...register('need_24hr_access')}
                style={{ flexShrink: 0, width: '24px', height: '24px', minWidth: '24px', minHeight: '24px' }}
              />
              <span className="forceBlack">
                24/7 Gate Access: +$15/month
              </span>
            </label>
          </div>

          <div>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
              <input
                className="checkbox"
                id="need_3x_week_access"
                type="checkbox"
                {...register('need_3x_week_access')}
                style={{ flexShrink: 0, width: '24px', height: '24px', minWidth: '24px', minHeight: '24px' }}
              />
              <span className="forceBlack">
                Unlimited Visits (3+ per week): +$15/month
              </span>
            </label>
          </div>
        </div>
      )}
    </div>
  )
}

export default LeaseDetailsStep
